import axios from "axios";
import { CandidateItemSetModel } from "models";
import { IAPIResult } from "models/interfaces";

export async function list() {
  // await Utils.sleep(300);

  const response = await axios.get<IAPIResult<CandidateItemSetModel[]>>(
    "/api.d/v1/ec/candidate-item/list"
  );
  return response.data;
}

export async function add(
  candidate_item_cd: string,
  quantity: number
): Promise<IAPIResult> {
  // await Utils.sleep(300);

  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/candidate-item/create",
    {
      candidate_item_cd,
      quantity,
    }
  );
  return response.data;
}

export async function del(candidate_item_cd: string): Promise<IAPIResult> {
  // await Utils.sleep(300);
  const response = await axios.delete<IAPIResult>(
    "/api.d/v1/ec/candidate-item/delete",
    { data: { candidate_item_cd } }
  );
  return response.data;
}
